import type { TOC } from '@ember/component/template-only';

import { MetricInfoMode } from '@databox/ember-integrations/lib/components/MetricInfoCard/MetricInfoCardEntryPoint';

import metricInfoAnchor from 'webapp/modifiers/metric-info-anchor';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type { MetricInfoModel } from 'webapp/services/metric-info';

interface Args {
	model: MetricInfoModel;
	// The card's own theme, for an icon on a surface themed apart from the app (the editors' dark panels).
	theme?: 'dark' | 'light';
}

// An info icon that shows the metric info card on hover (pinned by a click, a tap, Enter or Space).
const MetricInfoIconComponent: TOC<Args> = <template>
	<button
		type="button"
		class="metric-info-icon"
		aria-label="About {{@model.name}}"
		{{metricInfoAnchor @model trigger="hover" mode=MetricInfoMode.SUMMARY theme=@theme}}
	>
		<CommonUiIconComponent @name="InfoFill" @size="sm" />
	</button>
</template>;

export default MetricInfoIconComponent;
